<template>
  <CallScreen title="Roadside Assistance Advisor" />
</template>

<script>
import CallScreen from "@/components/CallScreen";

export default {
  name: "Roadside",
  components: {
    CallScreen
  }
};
</script>

<style></style>
